import {isNavigationItem, isNavigationRoot, type Navigation_V1, type NavigationRoot} from "#magnolia-layer/types/api";

export const resolveNavigationReference = async (root: string | undefined) => {
    const navigation = ref<NavigationRoot | null>(null);
    if (root) {
        const runtimeConfig = useRuntimeConfig();
        const navigationApi = runtimeConfig.public.mgnl.apiNavigation;
        const response = await useMagnoliaFetch<Navigation_V1>(
            navigationApi,
            {
                params: {
                    '@jcr:uuid': root
                }
            }
        );

        navigation.value = response.data.value ? response.data.value.results[0] : null;
    }
    return navigation;
}

export const resolveNavigation = (root: any) => {
    if (isNavigationRoot(root) || isNavigationItem(root)) {
        return root["@nodes"].flatMap(name => {
            const node = root[name];
            if (isNavigationItem(node)) {
                return node;
            }
            return [];
        });
    }
}
